export default __webpack_public_path__ + "static/media/BallCream.176a1734.svg";